
<div class="bacgroundstretch">
    <div class="container">
        <div class="row vertical-offset-100">
            <div class="col-md-4 col-md-offset-4" >
                <div class="panel panel-default" >
                    <div class="panel-heading">
                        <h3 class="panel-title">Please sign in</h3>
                    </div>
                    <div class="panel-body">
                        <form accept-charset="UTF-8" role="form">
                            <fieldset>
                                <div class="form-group">
                                    <input class="form-control" [(ngModel)]="wsiUrl" placeholder="WSIUrl" name="WSIUrl" type="text">
                                </div>
                                <div class="form-group">
                                    <input class="form-control" [(ngModel)]="username" placeholder="Username" name="Username" type="text">
                                </div>
                                <div class="form-group">
                                    <input class="form-control" placeholder="Password" [(ngModel)]="password" name="password" type="password" value="">
                                </div>
                                <input class="btn btn-lg btn-success btn-block" type="submit" (click)="Login()" value=" login">
                            </fieldset>
                        </form>
                        <h1>{{errorMessage}}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
